/**
 * CommerceChannelsProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'
import _ from 'lodash'
import CommerceChannelsContext from './commerce-channels-context'
import { fetchCommerceChannel } from './commerce-channels-api'

export default function CommerceChannelsProvider({ children }) {

  const state = {
    fetchCommerceChannel,
  }

  return (
    <CommerceChannelsContext.Provider value={state}>
      {children}
    </CommerceChannelsContext.Provider>
  )
}
